export default __webpack_public_path__ + "media/images/icons_fc/facturebleu-067b0abad192d4c467f001b9df5d8d2a.png";